import { AnimatePresence } from 'framer-motion';

import { selectDictionary } from 'features/dictionaries/dictionariesSelectors';

import { useAppSelector } from 'hooks/useTypedRedux';

import { Education as EducationType } from 'types/commons';

import { Dictionaries } from 'constants/enums';

import styles from '../EducationWorkExperience.module.scss';
import EducationItem from './EducationItem';

interface EducationProps {
  education: EducationType;
}

const Education = ({ education }: EducationProps) => {
  const educationDictionary = useAppSelector(
    selectDictionary(Dictionaries.Education)
  );
  const studyDictionary = useAppSelector(selectDictionary(Dictionaries.Study));
  const recordsToShowWithMappedLabels = (education?.records || []).map(
    (el) => ({
      ...el,
      degree:
        (educationDictionary.find((item) => item.value === el.degree)
          ?.label as string) || el.degree,
      fieldOfStudy:
        (studyDictionary.find((item) => item.value === el.fieldOfStudy)
          ?.label as string) || el.fieldOfStudy
    })
  );

  return (
    <div className={styles.educationSectionWrapper}>
      <AnimatePresence initial={false}>
        {recordsToShowWithMappedLabels.map((record, index) => (
          <EducationItem key={`education-${index}`} record={record} />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Education;
